import styled from "styled-components";
import { mobile } from "../responsive";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useState } from "react";


const Container = styled.div`
    width: 100vw;
    height: 100vh;
    background: linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), url("https://images.pexels.com/photos/9657060/pexels-photo-9657060.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1") center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
`

const Wrapper = styled.div`
    padding: 20px;
    width: 40%;
    background-color: #fff;
    ${mobile({ width: '75%' })}
`

const Title = styled.h1`
    font-size: 24px;
    font-weight: 300;
`

const Form = styled.form`
    display: flex;
    flex-wrap: wrap;
`

const Input = styled.input`
    flex: 1;
    min-width: 40%;
    margin: 20px 10px 0px 0px;
    padding: 10px;
`

const PasswordWrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 40%;
  margin: 20px 10px 0px 0px;
`;

const EyeIcon = styled.div`
  position: absolute;
  right: 10px;
  top: 12px;
  cursor: pointer;
  color: #555;
`;

const Agreement = styled.span`
    font-size: 12px;
    margin: 20px 0px;
`

const Button = styled.button`
    width: 40%;
    border: none;
    padding: 15px 20px;
    background-color: #206884;
    color: #fff;
    cursor: pointer;
` 

const Register = () => {
    
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <Container>
        <Wrapper>
            <Title>Crear una cuenta</Title>
            <Form>
                <Input placeholder="Nombre" />
                <Input placeholder="Apellido" />
                <Input placeholder="Email" />
                <Input placeholder="Usuario" />
                <PasswordWrapper>
                    <Input
                    placeholder="Password"
                    type={showPassword ? "text" : "password"}
                    />
                    <EyeIcon onClick={() => setShowPassword((p) => !p)}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                    </EyeIcon>
                </PasswordWrapper>

                <PasswordWrapper>
                    <Input
                    placeholder="Confirmar Password"
                    type={showConfirm ? "text" : "password"}
                    />
                    <EyeIcon onClick={() => setShowConfirm((p) => !p)}>
                    {showConfirm ? <VisibilityOff /> : <Visibility />}
                    </EyeIcon>
                </PasswordWrapper>
                <Agreement>
                    Acepto las condiciones
                </Agreement>
                <Button>CREAR</Button>
            </Form>
        </Wrapper>
    </Container>
  )
}

export default Register